import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personal-data-anre',
  templateUrl: './personal-data-anre.component.html',
  styleUrls: ['./personal-data-anre.component.scss']
})
export class PersonalDataAnreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
